import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Channel } from 'app/interfaces/channel';

@Component({
	selector: 'channel-details-embed',
	templateUrl: './channel-details-embed.component.html',
	styleUrls: ['./channel-details-embed.component.scss']
})

export class ChannelDetailsEmbedComponent implements OnInit {
	@Input() channel: Channel;
	@Input() form: NgForm;
	@Input() isActive: boolean;

	constructor() { }

	ngOnInit() { }

}
